import { render, staticRenderFns } from "./Newjourney.vue?vue&type=template&id=7de5e09a&scoped=true&"
import script from "./Newjourney.vue?vue&type=script&lang=js&"
export * from "./Newjourney.vue?vue&type=script&lang=js&"
import style0 from "./Newjourney.vue?vue&type=style&index=0&id=7de5e09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de5e09a",
  null
  
)

export default component.exports